<template>
    <div>
        <kt-panel>
            <kt-panel-body>
                <kt-row>
                    <kt-col lg="3" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="settlement_id">
                                {{ $t('label.settlement_id') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="settlement_id"
                                    name="settlement_id"
                                    disabled
                                    :value="form_data.settlement_id"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="status">
                                {{ $t('label.status') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="status"
                                    name="status"
                                    disabled
                                    :value="getStatusSrt(form_data.status)"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="created_at">
                                {{ $t('label.date_created') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="created_at"
                                    name="created_at"
                                    disabled
                                    :value="form_data.created_at"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="payment_date">
                                {{ $t('label.date_payed') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="payment_date"
                                    name="payment_date"
                                    disabled
                                    :value="form_data.payment_date"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="amount">
                                {{ $t('label.settlement_amount') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="amount"
                                    name="amount"
                                    disabled
                                    :value="form_data.amount"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="psp">
                                {{ $t('label.psp') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="psp"
                                    name="psp"
                                    disabled
                                    :value="form_data.psp"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group v-if="form_data.type == 6">
                            <kt-form-label for="wallet_hashid">
                                {{ $t('label.wallet_hashid') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="wallet_hashid"
                                    name="wallet_hashid"
                                    disabled
                                    :value="form_data.wallet_hashid"
                            >
                            </kt-form-control>
                        </kt-form-group>
                        <kt-form-group v-else>
                            <kt-form-label for="sheba_number">
                                {{ $t('label.sheba_number') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="sheba_number"
                                    name="sheba_number"
                                    disabled
                                    :value="form_data.sheba_number"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="gateway_id">
                                {{ $t('label.gateway_id') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="gateway_id"
                                    name="gateway_id"
                                    disabled
                                    :value="form_data.gateway_id"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="gateway_farsi_name">
                                {{ $t('label.gateway_farsi_name') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="gateway_farsi_name"
                                    name="gateway_farsi_name"
                                    disabled
                                    :value="form_data.gateway_farsi_name"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="bank_reference">
                                {{ $t('label.bank_reference') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="bank_reference"
                                    name="bank_reference"
                                    disabled
                                    :value="form_data.bank_reference"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
            </kt-panel-body>
        </kt-panel>
        <kt-panel v-if="form_data.details.length != 0">
            <kt-panel-body>
                <h5 class="mb-4">{{ $t('label.payment_details') }}</h5>
                <table class="table table-striped" style="font-size: 0.89rem;">
                    <thead>
                    <tr>
                        <td>{{ $t('label.amount') + ' (' + $t('currency.rial') + ')' }}</td>
                        <td v-if="form_data.type == 6">{{ $t('label.wallet_hashid') }}</td>
                        <td v-else>{{ $t('label.sheba_number') }}</td>
                        <td>{{ $t('label.payee_name') }}</td>
                        <td>{{ $t('label.bank_tracking_number') }}</td>
                        <td>{{ $t('label.status') }}</td>
                    </tr>
                    </thead>
                    <tbody style="white-space: nowrap;">
                    <tr
                            v-bind:key="index"
                            v-for="(detail, index) in form_data.details"
                    >
                        <td>{{ detail.amount }}</td>
                        <td v-if="form_data.type == 6">{{ form_data.wallet_hashid }}</td>
                        <td v-else>{{ detail.sheba_number }}</td>
                        <td>{{ detail.full_name }}</td>
                        <td>{{ detail.tracking_number }}</td>
                        <td><div :class="getStatusColor(detail.status)">{{ getStatusSrt(detail.status) }}</div></td>
                    </tr>
                    </tbody>
                </table>
            </kt-panel-body>
        </kt-panel>
    </div>

</template>

<script>
import { statusStr } from '@/constants/settlementStatus'
import {settlementStatus} from "@/constants/settlementStatus";
import commonAccessColumns from "../../transaction/datatable/coreCommonAccessColumns";
import { AuthorizationHeader } from '@/common/jwt.service'
import { ApiUrl } from '@/common/api.service'

export default {
    props: {
        form_data: {
            required: true,
        }
    },
    methods: {
        getStatusSrt(status_int){
            return statusStr.get(status_int)
        },
        getStatusColor(status_int){
            if(status_int === settlementStatus.CREATED || status_int === settlementStatus.SENT_TO_SHAPARAK) {
                return 'color-blue'
            }

            if(status_int === settlementStatus.ACCEPTED || status_int === settlementStatus.FINAL_PAYED) {
                return 'color-green'
            }

            if(status_int === settlementStatus.REJECTED) {
                return 'color-red'
            }
        },
    }
}
</script>

<style>
.color-red {
    color: red;
}
.color-green {
    color: #57c974;
}
.color-blue {
    color: #0f9af0;
}
</style>